export default __webpack_public_path__ + "static/media/27.06977b6a.jpg";